import md5 from "md5";
export const GradientImgs: { key: string; source: string }[] = [
  {
    key: "gradient-01",
    source: "/img/gradient-01.jpg",
  },
  {
    key: "gradient-02",
    source: "/img/gradient-02.jpg",
  },
  {
    key: "gradient-03",
    source: "/img/gradient-03.jpg",
  },
  {
    key: "gradient-04",
    source: "/img/gradient-04.jpg",
  },
  {
    key: "gradient-05",
    source: "/img/gradient-05.jpg",
  },
  {
    key: "gradient-06",
    source: "/img/gradient-06.jpg",
  },
  {
    key: "gradient-07",
    source: "/img/gradient-07.jpg",
  },
  {
    key: "gradient-08",
    source: "/img/gradient-08.jpg",
  },
  {
    key: "gradient-09",
    source: "/img/gradient-09.jpg",
  },
  {
    key: "gradient-10",
    source: "/img/gradient-10.jpg",
  },
  {
    key: "gradient-11",
    source: "/img/gradient-11.jpg",
  },
  {
    key: "gradient-12",
    source: "/img/gradient-12.jpg",
  },
  {
    key: "gradient-13",
    source: "/img/gradient-13.jpg",
  },
  {
    key: "gradient-14",
    source: "/img/gradient-14.jpg",
  },
  {
    key: "gradient-15",
    source: "/img/gradient-15.jpg",
  },
  {
    key: "gradient-16",
    source: "/img/gradient-16.jpg",
  },
  {
    key: "gradient-17",
    source: "/img/gradient-17.jpg",
  },
  {
    key: "gradient-18",
    source: "/img/gradient-18.jpg",
  },
  {
    key: "gradient-19",
    source: "/img/gradient-19.jpg",
  },
  {
    key: "gradient-20",
    source: "/img/gradient-20.jpg",
  },
  {
    key: "gradient-21",
    source: "/img/gradient-21.jpg",
  },
  {
    key: "gradient-22",
    source: "/img/gradient-22.jpg",
  },
  {
    key: "gradient-23",
    source: "/img/gradient-23.jpg",
  },
  {
    key: "gradient-24",
    source: "/img/gradient-24.jpg",
  },
  {
    key: "gradient-25",
    source: "/img/gradient-25.jpg",
  },
  {
    key: "gradient-26",
    source: "/img/gradient-26.jpg",
  },
  {
    key: "gradient-27",
    source: "/img/gradient-27.jpg",
  },
  {
    key: "gradient-28",
    source: "/img/gradient-28.jpg",
  },
  {
    key: "gradient-29",
    source: "/img/gradient-29.jpg",
  },
  {
    key: "gradient-30",
    source: "/img/gradient-30.jpg",
  },
];

function hashStringToNumber(str: string): number {
  const hash = md5(str);
  let seed = 0;
  for (let i = 0; i < hash.length; i++) {
    seed += hash.charCodeAt(i);
  }
  return seed;
}

function seededRandom(seed: number, range: number): number {
  const x = Math.sin(seed) * 10000;
  return Math.floor((x - Math.floor(x)) * range);
}

const gradientCount = GradientImgs.length;

export function determineGradient(
  name: string,
  forceGradientIndex?: number | null,
) {
  if (
    forceGradientIndex !== null &&
    forceGradientIndex !== undefined &&
    GradientImgs[forceGradientIndex]
  ) {
    return GradientImgs[forceGradientIndex].source;
  }
  const seed = hashStringToNumber(name) + 4;
  const index = seededRandom(seed, gradientCount);
  return GradientImgs[index].source;
}
